module.exports = __webpack_public_path__ + "static/Neha_Nagaraj-f857b06d6b741c393f7621016b1f7b86.jpg";